import httpClient from '@/api/httpClient'
import { defineStore } from 'pinia'
import { useStoryStore } from '@/stores/story'
import { useMessagesStore } from '@/stores/messages'

const includesBlankPlacements = (storyPlacements) => {
  return storyPlacements.map(pl => pl.id).includes(null)
}

export const useStoryPlacementsStore = defineStore('storyPlacements', {
  state: () => ({
    storyPlacements: [],
  }),

  getters: {
    withIdKeys({ storyPlacements }) {
      let obj = {}
      storyPlacements.forEach(place => { obj[place.id] = place })
      return obj
    },

    includesBlank({ storyPlacements }) {
      return includesBlankPlacements(storyPlacements)
    }
  },

  actions: {
    async fetch({ storyId }) {
      return httpClient
        .get(`/api/internal/stories/${storyId}/story_placements`)
        .then(({ data }) => {
          this.storyPlacements = data.story_placements
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
        })
    },

    addIssue({ issueId }) {
      this.storyPlacements.push({ issue_id: Number(issueId) })
    },

    addPage({ issueId, pageId }) {
      this.storyPlacements.push({ issue_id: Number(issueId), page_id: Number(pageId) })
    },

    addBlank({ storyId }) {
      // Only allow one at a time. Ideally, we'd allow adding multiple blanks but
      // it causes problems with unique keys, so I'm gonna leave it like this
      // until we have time to refactor a bit.
      if (includesBlankPlacements(this.storyPlacements)) return

      this.storyPlacements.push({
        id: null,
        story_id: storyId,
        issue_id: null,
        page_id: null
      })
    },

    updatePlacement(placement) {
      this.storyPlacements = this.storyPlacements.map(place => {
        return place.id === placement.id ? placement : place
      })
    },

    async updateStoryPlacement(placement) {
      this.updatePlacement(placement)

      // If there are multiple placements, use the first one for the publish_on date
      if (placement.id !== this.storyPlacements[0]?.id) return Promise.resolve()

      const issueId = placement.issue_id
      if (!issueId) return Promise.resolve()

      return useStoryStore().autoSetPubDateFromIssue({ issueId })
    },

    reset() {
      this.storyPlacements = []
    }
  },
})
